export async function prefetchFileFromUrl(
  fileUrl: string,
  fileName?: string
): Promise<File> {
  const response = await fetch(fileUrl);

  if (!response.ok) {
    throw new Error(`Failed to fetch file: ${response.status}`);
  }

  const blob = await response.blob();

  const name = fileName || fileUrl.split('/').pop() || 'prefetched-file';

  return new File([blob], name, { type: blob.type });
}

/**
 * Upload a file to a presigned S3 URL.
 */
export async function uploadFileToS3({
  file,
  uploadUrl,
}: {
  file: File;
  uploadUrl: string;
}): Promise<void> {
  const res = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    cache: 'no-store',
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
    },
  });

  if (!res.ok) {
    throw new Error(`Upload failed with status ${res.status}`);
  }
}
